function VerifyHrefContent(params) {
  // 創建一個新的 URLSearchParams 來保存驗證後的參數
  const sanitizedParams = new URLSearchParams();

  // 迭代所有參數並進行驗證
  for (const [key, value] of params) {
    // 檢查鍵和值是否包含合法字符
    if (IsValidInput(key) && IsValidInput(value)) {
      // 將合法的參數加入到驗證後的參數中
      sanitizedParams.append(key, value);
    }
  }

  return sanitizedParams;
}

// 驗證輸入是否包含合法字符
function IsValidInput(input) {
  // 排除特定字符，允許英文日文中文等其他符號，for路標名稱
  const disallowedCharsRegex = /[<>\"']/;
  return !disallowedCharsRegex.test(input);
}

let map_width = $(".map_block").width();
let initInfo,
  previous_declare_data,
  current_detail_data,
  current_list_data = {},
  current_chart_data = {};
$(".map_block").height(map_width);
let RegistrationNo = urlParams.get("id");
let offset = $("#water_pollution").offset();
let option = {
  parent: "previous_declare",
  subParent: "BottomAsh",
  children: "Air",
  year: "",
  month: 1,
};
$(".data_type").delegate("li", "click", function (e) {
  let id = $(this).data("type");
  if (id) {
    let url;
    if (location.href.indexOf("#") > -1) {
      url = location.href.split("#")[0];
      url += id;
    } else {
      url = `${location.href}`;
      url += id;
    }
    window.location.replace(url);
  }
});
const filterOption = async (this_, isParent, isChildren, isYear, type) => {
  let info = await initInfo.then((res) => res);
  let mobileType = "";
  if (isParent) {
    option.parent = type;
  } else if (isChildren) {
    option.children = type.substring(1);
    mobileType = $($(".data_type").children(".selected")[0]).data("type").replace("#", "");
  } else if (isYear) {
    option.year = $(this_).children("button") === "全部年度" ? "all" : parseInt($(this_).children("button").text());
    filterYearData();
  }
  let disabled = $(this_).data("disabled");
  if (option.parent === "latest_declare" || option.parent === "graph_data") {
    disabled = true;
  }
  if (type === "detect_data") {
    $(this_).parent(".select_dropbox").parent(".select_block").next(".sub_select_block").css("display", "block");
    $(this_).parent(".select_dropbox").parent(".select_block").next(".sub_select_block").next(".select_block").children(".title_block").addClass("disabled");
    checkOptionSelect();
  } else {
    $(this_).parent(".select_dropbox").parent(".select_block").next(".sub_select_block").css("display", "none");
    let detail = current_detail_data;
    if (!!!detail) {
      page_loader(true);
      detail = await fetch(`${host}/api/v1/Factory/Detail?RegistrationNo=${RegistrationNo}`).then((res) => res.json());
      current_detail_data = detail;
      page_loader(false);
    }
    let category = ["IsAir", "IsWater", "IsWaste", "IsToxic", "IsMetal", "IsGreenhouse", "IsPenalty"];
    let withCategory = [];
    let result = detail.Result;
    category.forEach((c) => {
      if (result[c]) {
        if (c === "IsGreenhouse") {
          c = "IsGreenHouse";
        }
        withCategory.push(c.substring(2));
      }
    });
    if (result["IsIncin"]) {
      $(".detect_data").css("display", "block");
    }

    $(".dynamic_data").empty();
    $(".row_select_button").empty();
    console.log("before", option.children);
    withCategory.forEach((category, i) => {
      if (i === 0) option.children = category;
      let title = table_data["latest_declare"][category]["title"];
      let list = `<li class="${i === 0 ? "selected" : ""}" data-acronym="${category === "Waste" ? "廢棄物" : category === "Toxic" ? "毒性化學物" : ""}" data-type="#${category}"><button>${title} </button></li>`;
      $(".dynamic_data").append(list);
      $(".row_select_button").append(list);
    });
    console.log("after", option.children);
  }
  if (disabled) {
    $(".year_select_block > .title_block").addClass("disabled");
    $(".year_slide_down_block").parent("div").addClass("disabled");
    $(".year_select_block > .title_block>.title").text("資料年度");
  } else {
    $(".year_select_block > .title_block").removeClass("disabled");
    $(".year_slide_down_block").parent("div").removeClass("disabled");
  }
  if ((isChildren || isParent) && option.parent === "previous_declare") {
    option.children = mobileType;
    previous_declare_data = overYearfetchApi(mobileType);
    filterYearData();
    selected_check();
  } else if (isParent && option.parent === "latest_declare") {
    let data = await fetch(`${host}/api/v1/Report/Latest?RegistrationNo=${info.RegistrationNo}`).then((res) => res.json());
    option.children = "Air";
    content(info, data.Result);
  } else if (type === "detect_data") {
    if (type === "detect_data") {
      if (info.IsIncin) {
        let IncinData = {};
        let detect = table_data["detect_data"];
        for (let i = 0; i < detect.length; i++) {
          let name = detect[i]["name"];
          let Incin_fetch = await fetch(`${host}/api/v1/Incin/${name}?RegistrationNo=${info.IncinNo}`).then((res) => res.json());
          if (!Incin_fetch.Error) {
            IncinData[name] = Incin_fetch.Result;
          }
        }
        let years = [];
        let tableData = table_data[type];
        tableData.forEach((t) => {
          let name = t.name;
          let yearName = t.year_name;
          IncinData[name].forEach((c) => {
            let year = c[yearName].indexOf("-") ? moment(c[yearName]).format("YYYY") : c[yearName];
            let filter = years.filter((y) => y === year);
            if (filter.length === 0) years.push(year);
          });
        });

        $(".year_select_block .select_dropbox").empty();
        $(".year_slide_down_block .year_select_block").empty();
        if (years.length === 0) {
          $(".year_select_block > .title_block >.title").text("資料年度");
          $(".year_select_block > .title_block").addClass("disabled");
        } else {
          years.forEach((year, i) => {
            let selected_year = option.year;
            if (option.year === "") {
              if (i === 0) {
                option.year = year;
                selected_year = year;
              }
            }
            $(".year_select_block > .title_block >.title").text(option.year);
            $(".year_slide_down_block").prev(".sort_block_mobile").children(".title").text(option.year);
            $(".year_select_block .select_dropbox").append(`<li class="${year === selected_year ? "selected" : ""}"><button>${year}</button>`);
            $(".year_slide_down_block .year_select_block").append(`<li class="${i === 0 ? "selected" : ""}"><button>${year}</button>`);
          });
        }
        content(info, IncinData);
      }
    }
  } else if (option.parent === "graph_data") {
    let option_child = !isChildren ? option.children : type.substring(1);
    let data;
    if (!!!current_chart_data[option_child]) {
      page_loader(true);
      data = await fetch(`${host}/api/v1/Chart/${option_child}?RegistrationNo=${RegistrationNo}`).then((res) => res.json());
      current_chart_data[option_child] = data;
      page_loader(false);
    } else {
      data = current_chart_data[option_child];
    }
    option.children = option_child;
    if (!data.Error) {
      data = data.Result;
      content(info, data);
    }
  }
  if (option.parent === "latest_declare" || option.parent === "graph_data") {
    $(".year_row_select").css("display", "none");
  } else {
    $(".year_row_select").css("display", "flex");
  }
};
$(".select_block > .select_dropbox, .year_select_block").delegate("li", "click", function (e) {
  let type = $(this).data("type") || option.parent;
  let isParent = $(this).parent(".select_dropbox").hasClass("select_parent_type");
  let isChildren = $(this).parent(".select_dropbox").hasClass("data_type");
  let isYear = $(this).parent(".select_dropbox").parent(".select_block").hasClass("year_select_block");
  if (isParent || (!isChildren && option.parent === "latest_declare")) {
    loadingBlock();
  }
  filterOption($(this), isParent, isChildren, isYear, type);
});
$(".mobile_select_dropbox > li").click(function (e) {
  e.stopPropagation();
  $(this).blur();
  let selected = $(this).hasClass("selected");
  $(".mobile_select_dropbox > li ").removeClass("selected");
  if (selected) {
    $(this).removeClass("selected");
  } else {
    $(this).addClass("selected");
    $(this).parent(".mobile_select_dropbox").parent("li").parent(".list").parent(".content_block").parent(".slide_down_block").slideUp();
    $("body").css("overflow", "unset");
  }
});
$(".slide_down_block .list ").delegate("li", "click", function (e) {
  $(this).children("button").blur();
  let isParent = $(this).parent(".list").hasClass("select_parent_type");
  let isChildren = $(this).parent(".list").hasClass("data_type");
  let isYear = $(this).parent(".list").hasClass("year_select_block");
  let type = $(this).data("type");
  let acronym = $(this).data("acronym");
  let selected = $(this).hasClass("selected");
  let isOpen = $(this).hasClass("open");
  $(this).parent(".list").children("li").removeClass("selected");
  let dropdown = $(this).children("ul").hasClass("mobile_select_dropbox");
  if (isParent) {
    loadingBlock();
  }
  if (dropdown) {
    if (isOpen) {
      $(this).removeClass("open");
      $(this).children("ul").slideUp();
    } else {
      $(this).addClass("open");
      $(this).children("ul").slideDown();
    }
  } else {
    $(this).parent(".list").children("li").removeClass("selected");
    $(this).addClass("selected");
    $(this).parent(".list").parent(".content_block").parent(".slide_down_block").slideUp();
    $("body").css("overflow", "unset");

    filterOption($(this), isParent, isChildren, isYear, type);
  }
  selected_mobile_check();
});

function selected_mobile_check() {
  $(".slide_down_block .list > li").each(function () {
    let acronym = $(this).data("acronym");
    if ($(this).hasClass("selected")) {
      let text = $(this).children("button").text();
      let final_text;
      if (acronym) {
        final_text = acronym;
      } else {
        final_text = text;
      }
      let title = $(this).parent(".list").parent(".content_block").parent(".slide_down_block").prev(".sort_block_mobile").children(".title").text(final_text);
    }
  });
}
$(document).ready(function () {
  document.title = "列管污染源資料 (含裁處資訊) 查詢系統-列管事業基本資訊"

  $(".print").click(function () {
    // setTimeout(() => , 100)
    window.print();
  });
  initInfo = fetchApi();

  selected_mobile_check();
  $(".block ").delegate(".data_block .no_data_table > a", "click", function () {
    let title = $(this).data("title");
    let content = $(this).data("content");
    $(".modal_block .modal_header > .title").text(title);
    $(".modal_block .modal_content").append(`<p>${content}</p>`);
    $(".modal_block .modal_content").removeClass("height_auto");
    $(".modal_block").fadeIn();
    $(".modal_block .modal_content button").focus();
    $(".modal_block").css("display", "flex");
    $("body").css("overflow", "hidden");
  });
});
async function overYearfetchApi(type, SelectedYear) {
  let detail = current_detail_data.Result;
  if (!!!current_detail_data) {
    detail = await initInfo.then((res) => res);
  }
  let otherDetail;
  let result = [];
  let years = [];
  if (type === "Penalty") {
    page_loader(true);
    otherDetail = await fetch(`${host}/api/v1/Penalty/Statistics?RegistrationNo=${RegistrationNo}`).then((res) => res.json());
  } else {
    if (!!!type) {
      type = detail.tableCategory[0];
      option.children = type;
    }
    if (!!!current_list_data[type]) {
      page_loader(true);
      otherDetail = await fetch(`${host}/api/v1/Report/${type}?RegistrationNo=${RegistrationNo}`).then((res) => res.json());
      current_list_data[type] = otherDetail;
    } else {
      otherDetail = current_list_data[type];
    }
  }
  if (detail.Result !== null) {
    if (type === "Penalty") {
      let penaltyResult = otherDetail.Result.PenalyList;
      if (penaltyResult.length > 0) {
        penaltyResult.forEach((p) => {
          result = result.concat(p.DATA);
        });
      }
      years = otherDetail.Result.Years;
    } else {
      result = otherDetail.Result;
      result.forEach((r) => {
        let filter_year = years.filter((year) => year === r.Year);
        if (filter_year.length === 0) {
          years.push(r.Year);
        }
      });
    }
    $(".year_row_select_button").empty();
    $(".year_slide_down_block .year_select_block").empty();
    if (years.length === 0) {
      $(".year_select_block > .title_block >.title").text("資料年度");
    } else {
      let desktop_year = mobileMediaQuery.matches ? years : years.length > 5 ? years.slice(0, 5) : years;
      desktop_year.forEach((year, i) => {
        if (!SelectedYear && i === 0) {
          option.year = year;
          // $(".year_select_block > .title_block >.title").text(year);
          $(".year_slide_down_block").prev(".sort_block_mobile").children(".title").text(year);
        }
        $(".year_select_block .select_dropbox").append(`<li class="${i === 0 ? "selected" : ""}"><button>${year}</button>`);
        $(".year_slide_down_block .year_select_block").append(`<li class="${i === 0 ? "selected" : ""}"><button>${year}</button>`);
        $(".year_row_select_button").append(`<li class="${i === 0 ? "selected" : ""}"><button>${year}</button>`);
      });

      $(".year_row_select_button").append(`<li class=""><button>全部年度</button>`);
    }
    option.year = SelectedYear ? SelectedYear : parseInt(years[0]);
    content(detail, result);
    page_loader(false);
    return result;
  }
}
$(".row_select_button").delegate("li", "click", function () {
  $(".row_select_button li ").removeClass("selected");
  $(this).addClass("selected");
  let type = $(this).data("type");
  option.children = type.replace("#", "");
  if (option.parent === "previous_declare") {
    previous_declare_data = overYearfetchApi(option.children);
  } else if (option.parent === "latest_declare") {
    let id = $(this).data("type");
    if (id) {
      let url;
      if (location.href.indexOf("#") > -1) {
        url = location.href.split("#")[0];
        url += id;
      } else {
        url = `${location.href}`;
        url += id;
      }
      window.location.replace(url);
    }
  } else {
    if (!!!current_chart_data[option.children]) {
      page_loader(true);
      initInfo
        .then((res) => res)
        .then((info) => {
          fetch(`${host}/api/v1/Chart/${option.children}?RegistrationNo=${RegistrationNo}`)
            .then((res) => res.json())
            .then((data) => {
              if (!data.Error) {
                current_chart_data[option.children] = data;
                let Data = data.Result;
                content(info, Data);
                page_loader(false);
              }
            });
        });
    } else {
      content(current_detail_data.Result, current_chart_data[option.children].Result);
    }
  }
});
$(".year_row_select_button").delegate("li button", "click", function () {
  $(".year_row_select_button li ").removeClass("selected");
  $(this).parent("li").addClass("selected");
  let text = $(this).text() === "全部年度" ? "all" : parseInt($(this).text());
  option.year = text;
  filterYearData();
  // overYearfetchApi(option.children)
});

const checkOptionSelect = async (detail) => {
  if (!detail) {
    page_loader(true);
    detail = await fetch(`${host}/api/v1/Factory/Detail?RegistrationNo=${RegistrationNo}`).then((res) => res.json());
    page_loader(false);
  }
  let category = ["IsAir", "IsWater", "IsWaste", "IsToxic", "IsMetal", "IsGreenhouse", "IsPenalty"];
  let withCategory = [];
  let result = detail.Result;
  category.forEach((c) => {
    if (result[c]) {
      if (c === "IsGreenhouse") {
        c = "IsGreenHouse";
      }
      withCategory.push(c.substring(2));
    }
  });
  if (result["IsIncin"]) {
    $(".detect_data").css("display", "block");
  }
  $(".row_select_button").empty();
  $(".dynamic_data").empty();
  withCategory.forEach((category, i) => {
    if (i === 0) option.children = category;
    let title = table_data["latest_declare"][category]["title"];
    let list = `<li class="${i === 0 ? "selected" : ""}" data-acronym="${category === "Waste" ? "廢棄物" : category === "Toxic" ? "毒性化學物" : ""}" data-type="#${category}"><button>${title} </button></li>`;
    $(".row_select_button").append(list);
    $(".dynamic_data").append(list);
  });
  if (mobileMediaQuery.matches) {
    if (option.parent === "detect_data") {
      $(".dynamic_data").empty();
      let html = `  <li class="selected" data-acronym='底渣原始' data-type="#BottomAsh">
                            <button>底渣原始檢測資料 </button>
                        </li>
                        <li data-type="#FlyAsh" data-acronym='飛灰穩定化'>
                            <button>飛灰穩定化檢測資料</button>
                        </li>
                        <li data-type="#Air" data-acronym='空污檢測'>
                            <button>空污檢測資料</button>
                        </li>
                        <li data-type="#YearlyReport" data-acronym='營運年報'>
                            <button>焚化廠營運年報</button>
                        </li>
                        <li data-type="#MonthlyReport" data-acronym='營運月報'>
                            <button>焚化廠營運月報</button>
                        </li>`;
      $(".dynamic_data").append(html);
      $(".type_slide_down_block .title").text("飛灰底渣");
    }
    selected_mobile_check();
  } else {
    selected_check();
  }
  return withCategory;
};
async function fetchApi() {
  let detail = current_detail_data;
  if (!!!detail) {
    page_loader(true);
    detail = await fetch(`${host}/api/v1/Factory/Detail?RegistrationNo=${RegistrationNo}`).then((res) => res.json());
    current_detail_data = detail;
  }
  let result = detail.Result;
  if (result !== null) {
    const baseEMAP = L.tileLayer("https://wmts.nlsc.gov.tw/wmts/EMAP/default/GoogleMapsCompatible/{z}/{y}/{x}", {
      minZoom: 15,
    });
    map = L.map("mapid", {
      layers: [baseEMAP],
      attributionControl: false,
      center: [result.Lat, result.Lng],
      zoom: 15,
    });
    L.marker([result.Lat, result.Lng]).addTo(map);
    result.tableCategory = await checkOptionSelect(detail);
    $(".detail_block .code").text(RegistrationNo);
    $(".detail_block .title").text(result.FacilityName);
    let data_flex = `<div class="update_date">最新資料匯入日期：${result.UpdateTime.Detail}</div>
                <div class="update_frequency">
                    <div></div>
                    <div class="">更新頻率：${result.UpdateFrequency}</div>
                </div>`;
    $(".detail_block .data_flex").append(data_flex);
    let html = ` <li><div>行業別</div><div>${result.IndustryName}</div></li>
                <li><div>地址</div><div>${result.FacilityAddress}</div></li>
                <li><div>所屬工業區</div><div>${result.IndustryAreaName}</div></li>`;
    $(".detail_block .extra_data").append(html);
    let labels = {
      IsAir: "AirReleaseDate",
      IsWater: "WaterReleaseDate",
      IsWaste: "WasteReleaseDate",
      IsToxic: "ToxicReleaseDate",
      IsPenalty: "",
    };
    let label_content = {
      IsAir: "空",
      IsWater: "水",
      IsWaste: "廢",
      IsToxic: "毒",
      IsPenalty: "裁",
    };
    let label_html = "";
    for (let label in labels) {
      let content = labels[label];
      let className = label[0].toLowerCase() + label.slice(1);
      if (result[label]) {
        if (content !== "") {
          if (result[content] !== null) {
            className += "Released";
            label_html += `<li class='released ${className} '>${label_content[label]} （${result[content]} 解列）</li>`;
          } else {
            label_html += `<li class='${className}'>${label_content[label]}</li>`;
          }
        } else {
          label_html += `<li class='${className}'>${label_content[label]}</li>`;
        }
      }
    }
    $(".detail_block .label_groups").append(label_html);
    previous_declare_data = overYearfetchApi(option.children);
  }
  $(".print_date span").text(moment().format("YYYY/MM/DD HH:mm:ss"));
  page_loader(false);
  return result;
}
function loadingBlock() {
  $(".result_block > .block").empty();
  let html = "";
  for (let i = 0; i < 2; i++) {
    html += `<div class=" loading_status_block">
                <div class="load_flex_block">
                    <div class="left">
                        <div class="border_left_title"></div>
                        <div class="title"></div>
                    </div>
                    <div class="right"></div>
                </div>
                <div class="load_block"></div>
                <div class="load_block"></div>
                <div class="load_block"></div>
                <div class="load_block"></div>
            </div>`;
  }
  $(".result_block > .block").append(html);
}
async function content(detail, contentData) {
  let type = option.parent;
  let tableData = type === "previous_declare" ? table_data["latest_declare"] : table_data[type];
  let table_category = type === "previous_declare" ? [option.children] : type !== "detect_data" ? detail.tableCategory : "";
  $(".result_block > .block").empty();

  if (tableData) {
    if (typeof table_category === "object") {
      table_category.forEach((t) => {
        let id = t;
        let category = typeof t.category === "string" ? thead[t.category] : tableData[id]["category"];
        let datas = [];

        if (type === "previous_declare") {
          datas =
            option.year === "all"
              ? contentData
              : contentData.filter((d) => {
                  let year = d.Year ? d.Year : parseInt(d.PENALTYYEAR);
                  return year === option.year;
                });
        } else {
          datas = contentData[id];
        }

        let html = "";
        if (type) html = declarationInfo(detail, id, tableData[id], datas, category);
        let toxicRTb = "";
        if (id === "Toxic") {
          let ToxicR = "Toxic_Release";
          category = tableData[ToxicR]["category"];
          toxicRTb = "";
          toxicRTb += `<table class="data_info_table">
                      <thead>  
                      <tr>`;
          category.forEach((c) => {
            toxicRTb += `<th>${c.title}</th>`;
          });
          toxicRTb += `</tr>
                        </thead>
                    <tbody>`;
          datas.forEach((d) => {
            if (d.ToxicType.includes("釋放量")) {
              toxicRTb += "<tr>";
              let lastIndex = category.length - 1;
              let lastSecondIndex = category.length - 2;
              category.forEach((c, index) => {
                let decimal_num = 0;
                if (d[c.name] && typeof d[c.name] === "string" && d[c.name].indexOf(".") > -1) {
                  let decimal = d[c.name].split(".");
                  decimal_num = decimal[decimal.length - 1].length;
                }
                let final_data = decimal_num > 4 ? parseFloat(d[c.name]).toFixed(4) : d[c.name];
                if (typeof final_data === "string") {
                  if (final_data && final_data.indexOf("-") > -1) {
                    final_data = moment(final_data).format("YYYY/MM/DD") !== "Invalid date" ? moment(final_data).format("YYYY/MM/DD") : final_data;
                  }
                }

                if (c.name === "EmiYear") {
                  final_data = `${d.EmiYear}年${d.EmiMonth}月`;
                }
                if (id === "Toxic") {
                  if (c.name === "EmiValue") {
                    final_data = `${parseFloat(d.EmiValue).toFixed(4)}<br/>(${d.ToxicType})`;
                  }
                }

                toxicRTb += `<td>${final_data}</td>`;
              });
            }
            toxicRTb += "</tr>";
          });
          toxicRTb += `</tbody>
                    </table>`;
        }

        $(".result_block > .block").append(html);
        $(".data_info").append(toxicRTb);
        //裁處資訊子案展開與收合
        $(".content .expand_table").click(function () {
          let open = $(this).hasClass("open");
          let dropdown = $(this).parent("div").parent(".content").next(".dropdown");
          if (open) {
            $(this).removeClass("open");
            $(this).text("展開");
            $(dropdown).slideUp();
          } else {
            $(this).addClass("open");
            $(this).text("收合");
            $(dropdown).slideDown();
          }
        });
        $(".content .TransgressState").click(function () {
          let index = $(this).data("index");
          DetailedInfo(datas, index, 1);
        });
        $(".content .more, .data_info_list .more").click(function () {
          let index = $(this).data("index");
          DetailedInfo(datas, index, 2);
        });
      });
    } else {
      tableData.forEach((data) => {
        let name = data.name;
        let year_name = data.year_name;
        if (contentData[name]) {
          let filter = contentData[name].filter((d) => d[year_name] && d[year_name].indexOf(option.year) > -1);
          contentData[name] = filter;
        }
      });
      let html = "";
      tableData.forEach((t) => {
        let id = t.name;
        let Tcategory = t.category ? t.category : shared.category;
        if (Tcategory.length < 4) {
          html = `
                    <div class="data_block data_blocks" id="${id}">
                        <div class="title_block">
                            <div class="left">
                                <div class="border_left_title is${id}"></div>
                                <div class="title">${t.title}</div>
                            </div>`;
          //焚化廠營運月報 && 空污檢測資料月份選項
          if (id === "MonthlyReport" || id === "Air") {
            html += `<div class="select_block month_select_block" >
                                    <button class="title_block">
                                        <div class="title"></div>
                                        <img src="img/icon/chevron-down.svg" class="svg" alt="">
                                    </button>
                                    <ul class="select_dropbox" data-type=${id}>`;
            for (let i = 0; i < 12; i++) {
              html += `<li class="${i === 0 ? "selected" : ""}"><button>${i + 1}月 </button></li>`;
            }
            html += `</ul>
                                </div>`;
          }
          html += `</div>
                             <div class="data_info">
                        <div class='triple_grid ${Tcategory.length === 3 ? "" : "double_grid"} '>`;

          let ini = contentData[id] ? contentData[id].reverse() : [];
          if (ini.length > 0) {
            ini = ini[option.month - 1];
          }
          Tcategory.forEach((c, i) => {
            let category = c.category;
            html += "<ul>";
            if (Tcategory.length === 3) {
              category.forEach((ca) => {
                let val = ini[ca.name] ? ini[ca.name] : "本期尚無資料";
                if (ca.name && ca.name === "APPLYYEAR") {
                  val = option.year;
                }
                html += `<li>
                                                <div>${ca.title}</div>
                                                <div>${val}</div>
                                            </li>`;
              });
            } else {
              if (i === 0) {
                category.forEach((ca) => {
                  let val;
                  if (ini[ca.name]) {
                    val = ini[ca.name].indexOf("-") > -1 ? moment(ini[ca.name]).format("YYYY/MM/DD") : ini[ca.name];
                  } else {
                    val = "本期尚無資料";
                  }
                  html += `<li>
                                                <div>${ca.title}</div>
                                                <div>${val}</div>
                                            </li>`;
                });
              } else {
                category.forEach((ca) => {
                  html += `<li>
                                                <div>
                                                    <div>${ca.title}</div>
                                                    <div>
                                                        <div>一號爐</div>
                                                        <div>二號爐</div>
                                                        <div>三號爐</div>
                                                        <div>四號爐</div>
                                                    </div>
                                                </div>
                                                <div>`;
                  for (let index = 1; index < 5; index++) {
                    let name = ca.name.indexOf("-") > -1 ? ca.name.replace("-", index) : `${ca.name}${index}`;
                    html += `<div>${ini[name] ? ini[name] : "本期尚無資料"}</div>`;
                  }
                  html += ` </div>
                                    </li>`;
                });
              }
            }
            html += "</ul>";
          });
          html += ` </div>
                            </div>`;
          html += `</div>`;
        } else {
          html = declarationInfo(detail, id, t, contentData[id], t.category);
        }
        $(".result_block > .block").append(html);
        selected_check();
      });
    }
    $(".modal_footer >button").click(function () {
      $(".modal_block").fadeOut(400);
      $("body").css("overflow", "unset");
      setTimeout(() => {
        $(".modal_block .modal_content").empty();
      }, 500);
    });
  } else {
    if (type === "graph_data") {
      GraphData(contentData);
    }
  }
  $(".data_block").css("display", "block");
  $(".month_select_block > .title_block").click(function (e) {
    e.stopPropagation();
    let dropdown = $(this).next(".select_dropbox");
    let disable = $(this).hasClass("disabled");
    let prev = $(this).hasClass("open");
    $(".select_block > .title_block").removeClass("open");
    $(".select_block > .select_dropbox").slideUp();
    if (!disable) {
      if (prev) {
        $(this).removeClass("open");
        dropdown.slideUp();
      } else {
        dropdown.slideDown();
        $(this).addClass("open");
      }
    }
  });
  $(".month_select_block > .select_dropbox li").click(function (e) {
    let value = parseInt($(this).children("button").text()) - 1;
    option.month = value;
    let type = $(this).parent(".select_dropbox").data("type");
    let Tcategory = type === "Air" ? table_data["detect_data"][2]["category"] : shared.category;
    let html = `<div class="data_info">
                        <div class='triple_grid ${Tcategory.length === 3 ? "" : "double_grid"} '>`;
    let ini = contentData[type];
    ini = ini[value];
    Tcategory.forEach((c, i) => {
      let category = c.category;
      html += "<ul>";
      if (Tcategory.length === 3) {
        category.forEach((ca) => {
          let val = ini[ca.name] ? ini[ca.name] : "本期尚無資料";
          if (ca.name && ca.name === "APPLYYEAR") {
            val = option.year;
          }
          html += `<li>
                                    <div>${ca.title}</div>
                                    <div>${val}</div>
                                </li>`;
        });
      } else {
        if (i === 0) {
          category.forEach((ca) => {
            let val;
            if (ini[ca.name]) {
              val = ini[ca.name].indexOf("-") > -1 ? moment(ini[ca.name]).format("YYYY/MM/DD") : ini[ca.name];
            } else {
              val = "本期尚無資料";
            }
            html += `<li>
                                        <div>${ca.title}</div>
                                        <div>${val}</div>
                                    </li>`;
          });
        } else {
          category.forEach((ca) => {
            html += `<li>
                                        <div>
                                            <div>${ca.title}</div>
                                            <div>
                                                <div>一號爐</div>
                                                <div>二號爐</div>
                                                <div>三號爐</div>
                                                <div>四號爐</div>
                                            </div>
                                            </div>
                                        <div>`;
            for (let index = 1; index < 5; index++) {
              let name = ca.name.indexOf("-") > -1 ? ca.name.replace("-", index) : `${ca.name}${index}`;
              html += `<div>${ini[name] ? ini[name] : "本期尚無資料"}</div>`;
            }
            html += ` </div>
                                    </li>`;
          });
        }
      }
      html += "</ul>";
    });
    html += ` </div>`;
    $(".data_blocks").each(function () {
      let ID = $(this).attr("id");
      if (ID === type) {
        $(this).children(".data_info").empty();
        $(this).children(".data_info").append(html);
      }
    });
  });
  if (tabletMediaQuery.matches) {
    $(".data_info").each(function () {
      let list = $(this).children(".data_info_list");
      list.each(function (i) {
        if (i === 0) {
          $(this).css("display", "block");
        }
      });
      if (list.length > 1) {
        $(this).children(".show_all_btn").css("display", "block");
      }
    });
    $(".show_all_btn").click(function () {
      let expand = $(this).hasClass("expand");
      let list = $(this).parent(".data_info").children(".data_info_list");
      if (expand) {
        $(this).removeClass("expand");
        $(this).text("展開全部");
        list.each(function (i) {
          if (i !== 0) $(this).slideUp();
        });
      } else {
        $(this).addClass("expand");
        $(this).text("收合");
        list.each(function (i) {
          if (i !== 0) {
            $(this).slideDown();
          }
        });
      }
    });
  }
}
async function filterYearData(datas) {
  let detail = await initInfo.then((res) => res);
  if (option.parent === "previous_declare") {
    let data = await previous_declare_data.then((res) => res);
    let result;
    if (option.children === "Penalty") {
      result = option.year === "all" ? data : data.filter((d) => d.PENALTYYEAR == option.year);
    } else {
      result = option.year === "all" ? data : data.filter((d) => d.Year === option.year);
    }
    content(detail, result);
  } else if (option.parent === "detect_data") {
    let IncinData = {};
    let detect = table_data["detect_data"];
    for (let i = 0; i < detect.length; i++) {
      let name = detect[i]["name"];
      let Incin_fetch = await fetch(`${host}/api/v1/Incin/${name}?RegistrationNo=${detail.IncinNo}`).then((res) => res.json());
      if (!Incin_fetch.Error) {
        IncinData[name] = Incin_fetch.Result;
      }
    }
    content(detail, IncinData);
  }
}
function declarationInfo(detail, id, t, datas, category) {
  let other_data = t.other_data;
  let html = `
                <div class="data_block data_blocks" id="${id}">
                    <div class="title_block">
                        <div class="left">
                            <div class="border_left_title is${id}"></div>
                            <div class="title">${t.title}</div>
                        </div>
                        <div class="right">`;

  if (detail["UpdateTime"][id]) {
    if (t.unit) {
      html += '<div class="unit">單位：公噸 </div>';
    }
    html += '<div class="updated">';
    if (t.unit) {
      html += '<div class="border_left"></div> ';
    }
    if (detail["UpdateTime"][id]) {
      html += ` <div class="update_date">更新日期：${detail["UpdateTime"][id]}</div>
                    </div>`;
    }
  }
  html += "</div> </div>";

  if (datas && datas.length > 0) {
    html += ` <div class="data_info ${category.length > 6 ? "table_block" : ""}">
                    <table class="data_info_table ${category.length > 6 ? "scroll_table" : ""}">
                <thead>
            <tr>`;
    if (t.id === "Penalty") {
      category.forEach((c, i) => {
        let className = "width_90";
        if (i === 2) {
          className = "width_108";
        } else if (i === 4) {
          className = "width_140";
        } else if (i === category.length - 1 || i === category.length - 2) {
          className = "width_xs";
        }
        // || i === (category.length - 2)
        html += `<th class="${className}">${c.title}</th>`;
      });
      html += `</tr>
                        </thead>
                    </table>
                <ul class="dropdown_table">`;

      datas.forEach((d, i) => {
        html += `<li>
                                <div class="content">
                                    <div class="width_90">${d.PENALTYDATE}</div>
                                    <div class="width_90">${d.COUNTY}</div>
                                    <div class="width_108">${d.DOCUMENTNO}<br>
                                      (<button class="TransgressState" data-index="${i}" aria-label="檢視違反事實 詳細內容">檢視違反事實</button>)
                                    </div>
                                    <div class="width_90">${d.TRANSGRESSDATE}</div>
                                    <div class="width_140">${d.TRANSGRESSLAW}</div>
                                    <div class="width_90">NT$${thousands_separators(parseInt(d.PENALTYMONEY))}</div>
                                    <div class="width_xs">${d.ISIMPROVE}</div>
                                    <div class="width_xs"><button class="more" data-index=${i}>查看</button></div>
                                </div>`;

        html += `</li>`;
      });
      html += "</ul>";
    } else {
      category.forEach((c) => {
        html += `<th>${c.title}</th>`;
      });
      html += `</tr>
                    </thead>
                <tbody>`;
      datas.forEach((d) => {
        if (id === "Toxic") {
          if (!d.ToxicType.includes("釋放量")) {
            html += "<tr>";
            let lastIndex = category.length - 1;
            let lastSecondIndex = category.length - 2;
            category.forEach((c, index) => {
              let decimal_num = 0;
              if (d[c.name] && typeof d[c.name] === "string" && d[c.name].indexOf(".") > -1) {
                let decimal = d[c.name].split(".");
                decimal_num = decimal[decimal.length - 1].length;
              }
              let final_data = decimal_num > 4 ? parseFloat(d[c.name]).toFixed(4) : d[c.name];
              if (typeof final_data === "string") {
                if (final_data && final_data.indexOf("-") > -1) {
                  final_data = moment(final_data).format("YYYY/MM/DD") !== "Invalid date" ? moment(final_data).format("YYYY/MM/DD") : final_data;
                }
              }

              if (c.name === "EmiYear") {
                final_data = `${d.EmiYear}年${d.EmiMonth}月`;
              }
              if (c.name === "EmiValue") {
                final_data = `${parseFloat(d.EmiValue).toFixed(4)}<br/>(${d.ToxicType})`;
              }

              html += `<td>${final_data}</td>`;
            });
            html += "</tr>";
          }
        } else {
          html += "<tr>";
          let lastIndex = category.length - 1;
          let lastSecondIndex = category.length - 2;
          category.forEach((c, index) => {
            let decimal_num = 0;
            if (d[c.name] && typeof d[c.name] === "string" && d[c.name].indexOf(".") > -1) {
              let decimal = d[c.name].split(".");
              decimal_num = decimal[decimal.length - 1].length;
            }
            let final_data = decimal_num > 4 ? parseFloat(d[c.name]).toFixed(4) : d[c.name];
            if (typeof final_data === "string") {
              if (final_data && final_data.indexOf("-") > -1) {
                final_data = moment(final_data).format("YYYY/MM/DD") !== "Invalid date" ? moment(final_data).format("YYYY/MM/DD") : final_data;
              }
            }

            if (c.name === "EmiYear") {
              final_data = `${d.EmiYear}年${d.EmiMonth}月`;
            }
            html += `<td>${final_data}</td>`;
          });
          html += "</tr>";
        }
      });
      html += `</tbody>
                    </table>`;
    }
    datas.forEach((d, index) => {
      html += `<ul class="data_info_list">`;
      category.forEach((c, i) => {
        if (t.id === "Penalty") {
          if (i === category.length - 1) {
            html += `<li>
                                        <div>${c.title}</div>
                                        <div><button class="more" data-index=${index}>查看</button></div>
                                    </li>`;
            // } else if (i === category.length - 2) {
            // html += `<li>
            //             <div>${c.title}</div>
            //             <div><button class="expand_table" >查看</button></div>
            //         </li>`;
          } else {
            html += `<li>
                                        <div>${c.title}</div>
                                        <div>${c.name === "PENALTYMONEY" ? `NT$${thousands_separators(parseInt(d[c.name]))}` : d[c.name]}</div>
                                    </li>`;
          }
        } else {
          html += `<li>
                                <div>${c.title}</div>
                                <div>${d[c.name]}</div>
                            </li>`;
        }
      });
      html += " </ul>";
    });
    if (datas.length > 1) {
      html += `<button class="show_all_btn ${option.parent === "detect_data" ? "mb-16" : ""}">展開全部</button>`;
    }
    html += `</div>`;
  } else if (datas && datas.length === 0) {
    let noResult = t.noResult;
    if (noResult) {
      html += `<div class="no_data_table"> 
                目前無申報資料${noResult.status ? `（<a href="javascript: void(0)" role="button" data-title="${noResult.title} "  data-content="${noResult.content} ">參見說明</a>）` : ""}</div>`;
    } else {
      html += `<div class="no_data_table">目前無申報資料</div>`;
    }
  }
  if (other_data) {
    html += `<ul class="other_data">`;
    other_data.forEach((o) => {
      if (o.content) {
        html += `<li>
                                <div class="title">${o.title}</div>`;
        if (o.content_list) {
          html += ` <ul class="sub_list">`;
          o.content_list.forEach((l, i) => {
            html += `<li>
                                        <div>${i + 1}.</div>
                                        <div>${l}</div>
                                    </li>`;
          });
          html += ` </ul>`;
        }
        html += `<div class="desc">${o.content}</div>
                            </li>`;
      } else if (o.description_list) {
        html += ` <li><div class="desc_block">`;
        o.description_list.forEach((l) => {
          html += `<p>${l}</p>`;
        });
        html += `</div><li>`;
      } else {
        html += `<li>
                                <div class="title">${o.title}</div>
                                <ul class="sub_list">`;
        o.content_list.forEach((l, i) => {
          html += `<li>
                                    <div>${i + 1}.</div>
                                    <div>${l}</div>
                            </li>`;
        });
        html += ` </ul>
                        </li>`;
      }
    });
    html += `</ul>`;
  }
  html += `</div>`;
  return html;
}
function DetailedInfo(datas, index, type) {
  let html = "";
  if (type === 1) {
    html = `<p>${datas[index]["TRANSGRESSSTATE"] === "" ? "無相關資訊" : datas[index]["TRANSGRESSSTATE"]}</p>`;
  } else {
    html = `<div class="ul_grid">
                <ul class="ul_block">
                    <li>
                      <div class="title">主旨</div>
                      <div class="text">${datas[index].SUBJECT}</div>
                    </li>
                    <li>
                      <div class="title">裁處理由及法令</div>
                      <div class="text">${datas[index].GISTDEFINE}</div>
                    </li>
                    <li>
                      <div class="title">限改日期</div>
                      <div class="text">${datas[index].IMPROVEDEADLINE ? datas[index].IMPROVEDEADLINE : "-"}</div>
                    </li>
                    <li>
                      <div class="title">改善完妥與否</div>
                      <div class="text">${datas[index].ISIMPROVE}</div>
                    </li>      
                    <li>
                      <div class="title">複查稽查結果</div>
                      <div class="text">${datas[index].INSPECTIONCONDITION ? datas[index].INSPECTIONCONDITION : "-"}</div>
                    </li>
                    <li>
                      <div class="title">複查稽查單稽查日期</div>
                      <div class="text">${datas[index].INSPECTIONDATETIMES ? datas[index].INSPECTIONDATETIMES : "-"}</div>
                    </li>
                    <li>
                      <div class="title">違規人管制編號 
                        <div class="tooltip_btn" >
                          <img src="img/icon/circle-information.svg" class="svg">
                            <div class="tooltip">系統提供列管污染源及裁處兩類資訊，針對列管污染源之「管制編號」為8碼，主要作為申報、各式污染源許可申請時使用；而稽查裁處時使用之「稽查管制編號」為12碼。實務上執行稽查裁處時可直接以「管制編號」或是再給予一個「稽查管制編號」進行裁處，而造成於裁處資訊項下查詢時有2種管制編號的情形。
                            </div>
                          </div>
                        </div> 
                      <div class="text">${datas[index].TRANSGRESSCONTROLID}</div>
                    </li>                
                    <li>
                        <div class="title">違規人名稱</div>
                        <div class="text">${datas[index].TRANSGRESSNAME}</div>
                    </li>
                    <li>
                      <div class="title">統一編號</div>
                      <div class="text">${datas[index].FACUNIFORMNO ? datas[index].FACUNIFORMNO : "-"}</div>
                    </li>
                    <li>
                      <div class="title">公司（工廠）地址</div>
                      <div class="text">${datas[index].FACADDRESS}</div>
                    </li>
                    <li>
                      <div class="title">污染類別</div>
                      <div class="text">${datas[index].TRANSGRESSTYPE}</div>
                    </li>
                    <li>
                      <div class="title">違反地址</div>
                      <div class="text">${datas[index].TRANSGRESSADDRESS}</div>
                    </li> 
                    <li>
                      <div class="title">違反事實</div>
                      <div class="text">${datas[index].TRANSGRESSSTATE}</div>
                    </li>                         
                </ul>
                <ul class="ul_block">

                    <li>
                      <div class="title">情節重大</div>
                      <div class="text">${datas[index].ISIMPORTANT !== "" ? datas[index].ISIMPORTANT : "-"}</div>
                    </li>        
                    <li>
                      <div class="title">其他處罰方式</div>
                      <div class="text">${datas[index].PENALTYKIND}</div>
                    </li>
                    <li>
                      <div class="title">不法利得</div>
                      <div class="text">
                        ${datas[index].ILLEGALMONEY ? `NT$${datas[index].ILLEGALMONEY}` : "-"}
                      </div>
                    </li>
                    <li>
                      <div class="title">水污追繳不法利得</div>
                      <div class="text">
                        ${datas[index].TRACKILLEGALMONEY ? `NT$${datas[index].TRACKILLEGALMONEY}` : "-"}
                      </div>
                    </li>       
                    <li>
                      <div class="title">是否減免罰鍰</div>
                      <div class="text">${datas[index].ISREDUCEMONEY !== "" ? datas[index].ISREDUCEMONEY : "-"}</div>
                  </li>
                    <li>
                      <div class="title">罰鍰是否繳清</div>
                      <div class="text">${datas[index].PAYMENTSTATE}</div>
                    </li>
                    <li>
                      <div class="title">是否進行催繳</div>
                      <div class="text">${datas[index].ISREMINDER}</div>
                    </li>   
                    <li>
                      <div class="title">是否行政移送</div>
                      <div class="text">${datas[index].ISADMINCOURT}</div>
                    </li>
                    <li>
                      <div class="title">是否訴願訴訟</div>
                      <div class="text">${datas[index].ISPETITION}</div>
                    </li>
                    <li>
                      <div class="title">訴願提出日期</div>
                      <div class="text">${datas[index].LAWSUITDATE1 ? datas[index].LAWSUITDATE1 : "-"}</div>
                    </li>                   
                    <li>
                      <div class="title">訴願訴訟結果</div>
                      <div class="text">${datas[index].PETITIONRESULTS ? datas[index].PETITIONRESULTS : "-"}</div>
                    </li>
                    <li>
                      <div class="title">陳情意見結果</div>
                      <div class="text">${datas[index].APPEALRESCIND !== "" ? datas[index].APPEALRESCIND : "-"}</div>
                    </li>
                    <li>
                      <div class="title">審議機關</div>
                      <div class="text">${datas[index].PETITIONAGENCY !== "" ? datas[index].PETITIONAGENCY : "-"}</div>
                    </li>                       
                    <li>
                      <div class="title">核准復工日期</div>
                      <div class="text">${datas[index].ALLOW_REWORK_DATA !== "" && datas[index].ALLOW_REWORK_DATA !== null ? datas[index].ALLOW_REWORK_DATA : "-"}</div>
                    </li>
                </ul>
            </div>
            <div class="description_block">
                <div class="title"><img src="img/icon/circle-information.svg" class="svg" alt="">違規人管制編號</div>
                <div class="text">系統提供列管污染源及裁處兩類資訊，針對列管污染源之「管制編號」為8碼，主要作為申報、各式污染源許可申請時使用；而稽查裁處時使用之「稽查管制編號」為12碼。實務上執行稽查裁處時可直接以「管制編號」或是再給予一個「稽查管制編號」進行裁處，而造成於裁處資訊項下查詢時有2種管制編號的情形。</div>
            </div>`;
  }

  $(".modal_block .modal_header > .title").text(`【${type === 1 ? "違反事實" : "詳細資訊"}】裁處書字號 ${datas[index]["DOCUMENTNO"]}`);
  $(".modal_block .modal_content").append(html);
  $(".modal_block .modal_content").removeClass("height_auto");
  $(".modal_block").fadeIn();
  $(".modal_block .modal_content button").focus();
  $(".modal_block").css("display", "flex");
  $("body").css("overflow", "hidden");
}

$(".download_button").click(function () {
  $(this).attr("href", `${host}api/v1/Factory/Export?RegistrationNo=${RegistrationNo}`);
});

async function GraphData(data) {
  let tableData = table_data["latest_declare"][option.children];
  let noResult = tableData.noResult;
  let html = `<div class="data_block data_blocks">
                    <div class="title_block graph_title_block">
                        <div class="left">
                            <div class="border_left_title is${option.children}"></div>
                            <div class="title">${tableData.title}</div>
                        </div>
                        <div class="desc">
                        本圖表僅供參考，呈現近三期曾申報之污染物，點選圖例文字選擇是否展示該時段資料
                    </div>
                    </div> `;
  if (data.data && data.data.length > 0) {
    html += ` <ul class='graph_label'>`;
    data.data.forEach((d) => {
      html += ` <li>
                                                <div class='circle'></div>
                                                <div class='text'>${d.name}</div>
                                            </li>`;
    });
    html += `</ul>
                    <div class="data_info">
                        <div class="graph_block" id="graph_block"></div>
                      
                    </div>
                </div>`;
  } else {
    html += `<div class="no_data_table"> 
                目前無申報資料${noResult.status ? `（<a href="javascript: void(0)" role="button" data-title="${noResult.title}"  data-content="${noResult.content} ">參見說明</a>）` : ""}</div>`;
  }
  $(".result_block > .block").append(html);
  if (data.data && data.data.length > 0) {
    data.data.map((d) => {
      d.data = d.value;
      return d;
    });
    //移除null值
    for (let index = 0; index < data.categories.length; index++) {
      if (data.data.every((array) => array.data[index] === null)) {
        data.data.forEach((array) => array.data.splice(index, 1));
        data.categories.splice(index, 1);
        index--;
      }
    }

    Highcharts.chart("graph_block", {
      colors: ["rgba(130, 142, 145, 1)", "rgba(11, 60, 73, 1)", "rgba(6, 29, 36, 1)"],
      chart: {
        type: "bar",
      },
      title: {
        text: null,
      },
      xAxis: {
        categories: data.categories,
        // title: {
        //     text: null
        // },
        labels: {
          useHTML: true, //Set to true
          style: {
            width: mobileMediaQuery.matches ? "48px" : "80px",
            whiteSpace: "normal", //set to normal
          },
          formatter: function () {
            //use formatter to break word.
            return `<div align="center" style="word-wrap: break-word;word-break: break-all;width: ${mobileMediaQuery.matches ? "48px" : "80px"}; font-size:0.825rem; display: -webkit-box; -webkit-line-clamp: 2;-webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">${
              this.value
            }</div>`;
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: tableData.title === "裁處資訊" ? "罰金(元)" : "檢測數值（公噸）",
        },
      },
      tooltip: {
        valueSuffix: tableData.title === "裁處資訊" ? " 元" : " 公噸",
      },

      plotOptions: {
        bar: {
          dataLabels: {
            enabled: false,
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      series: data.data,
    });
  }
}

$(".modal_sanction .modal_footer > .print").click(function () {
  $(".modal_print span").text(moment().format("YYYY/MM/DD HH:mm:ss"));
});

// }
